import { useState } from "react";
import { speakEnglish } from "./audio";
import { SceneCard } from "./SceneCard";
import type { PlayItem } from "./types";

export function FramePlayer({ item, onSubmit }: { item: PlayItem; onSubmit: (selected: unknown) => void }) {
  const [picked, setPicked] = useState<string | null>(null);
  const options = item.options ?? [];
  const pictures = item.pictures ?? options;
  const scene = item.scene || pictures[0] || "box";

  return (
    <div>
      <div className="tools">
        {item.audio || item.prompt ? (
          <button type="button" className="btn ghost" onClick={() => speakEnglish(item.audio || item.prompt)}>
            Послушать реплику
          </button>
        ) : null}
      </div>
      {item.type === "choose_picture" ? (
        <div className="pic-grid">
          {pictures.map((pic) => (
            <SceneCard key={pic} word={pic} selected={picked === pic} onClick={() => setPicked(pic)} />
          ))}
        </div>
      ) : (
        <>
          <SceneCard word={scene} />
          <div className="tools">
            {options.map((opt) => (
              <button key={opt} type="button" className={`btn${picked === opt ? " steel" : ""}`} onClick={() => setPicked(opt)}>
                {opt}
              </button>
            ))}
          </div>
        </>
      )}
      <button type="button" className="btn" disabled={!picked} onClick={() => onSubmit(picked)}>Мотор!</button>
    </div>
  );
}
